import * as React from "react";
import { observer } from "mobx-react";

// imported only for typings
// these are passed to the component from index.ts
import { BaseDict } from "./dict";
import { SportsMultiViewBlockData } from "./data";

// external components
import * as CMP from "./components";
import { HeadingTypeTwo, InstantCollapsible, Message, Loader } from "sb-resp-ui";
import { ContainerQuery } from "react-container-query";
import { config } from "./config";
import { MultiViewLeagueInfo, MultiViewBranchType } from "./data/models";
import { RenderMarketsQueryFilter } from "./data/helpers/RenderMarketsQueryFilter";

/*
    Setup testing tools for MobX
    uncoment the <DevTools /> at the end of the SportsMultiViewBlock component
*/
// import DevTools from "mobx-react-devtools";
// import { setLogEnabled, setUpdatesEnabled, setGraphEnabled } from "mobx-react-devtools";
// if (process.env.NODE_ENV === "development") {
//     setLogEnabled(true);
//     setUpdatesEnabled(true);
//     setGraphEnabled(true);
// }

@observer
export class SportsMultiViewBlock extends React.Component<{
    dataProvider: SportsMultiViewBlockData,
    dict: BaseDict,
    cms: any
}, {
    dataProvider: SportsMultiViewBlockData
}> {
    dict: BaseDict;
    cms: any;

    constructor(props) {
        super(props);

        // setup dictionary
        this.dict = this.props.dict;

        // setup data provider
        this.state = {
            dataProvider: this.props.dataProvider
        }

        this.cms = this.props.cms;
    }

    renderMarketNames(marketNames, query) {
        let marketsTrimmed = RenderMarketsQueryFilter(Object.keys(marketNames), query);

        let leagueMarketNames = marketsTrimmed.map((marketKey, index) => {
            let names = marketNames[marketKey].map((name) => this.dict[name] || name);
            return <CMP.MarketName key={`${marketKey}__${index}`} marketName={names} />
        });

        return (
            <div
                className="rj-sports-multiview__league-heading-section rj-sports-multiview__league-heading-markets">
                {leagueMarketNames}
            </div>
        )
    }

    renderLeaguesByBranch(branch: MultiViewBranchType, renderedEvents, query) {
        return (this.state.dataProvider.getSortedLeaguesByBranch.map((league, index) => {
            if (!league || league.eventIds.length === 0) { return; }

            let shouldExpandLeague = renderedEvents < this.cms.MinNumberOfEvents;
            renderedEvents += league.eventIds.length;
            return (
                <InstantCollapsible key={`leagueRowID_${league.id}`} initiallyExpanded={shouldExpandLeague} trigger={
                    <HeadingTypeTwo modifier="multiview" >
                        <CMP.LeagueName
                            name={league.name}
                            count={league.eventIds.length}
                            showNumberOfEvents={!!this.cms.ShowNumberOfLeagueEventsInBrackets}
                        />
                        {this.renderMarketNames(branch.marketNames, query)}
                    </HeadingTypeTwo>
                }
                    content={
                        <div data-uat="div-multiview-event-cards-section" className="rj-sports-multiview__event-cards-section">
                            {this.renderLeagueEvents(league, query)}
                        </div>
                    }
                />
            )
        }));
    }

    renderLeagueEvents(league: MultiViewLeagueInfo, query) {
        return (league.eventIds.map((eventId, index) => {
            let event = this.state.dataProvider.getEvent(eventId);
            let branchMarkets = event && this.state.dataProvider.getEventMarkets(event);

            return (<CMP.EventCard
                key={`${index}_${eventId}_`}
                event={event}
                handler={this.state.dataProvider.openEventView}
                dict={this.dict}
                query={query}
                isInSlip={this.state.dataProvider.betSlipUtil.isOddInSlip}
                branchMarkets={branchMarkets} />);
        }));
    }

    renderLeagueSection(branch: MultiViewBranchType, query) {
        return (
            <div className="rj-sports-multiview__league-section">
                {this.state.dataProvider.getNumberOfLeagueEvents(branch) === 0 ?
                    <Message text={this.dict.NoTodaysEvents} /> :
                    this.renderLeaguesByBranch(branch, 0, query)
                }
            </div>
        );
    }

    renderBranch(branch, query) {
        return (
            branch ?
                <div data-uat="div-multiview-sport" className="rj-sports-multiview">
                    <CMP.HeadingTypeOne modifier="multiview">
                        <CMP.SportHeaderName
                            shouldShowEventsCount={!!this.cms.ShowNumberOfLeagueEventsInBrackets}
                            label={branch.name}
                            count={this.state.dataProvider.getNumberOfLeagueEvents(branch)}
                        />
                    </CMP.HeadingTypeOne>
                    {this.renderLeagueSection(branch, query)}
                </div>
                : <Loader />

        );
    }

    /* istanbul ignore next */
    render() {
        // \/ DO NOT TOUCH THIS EVER!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        this.state.dataProvider;
        this.state.dataProvider.leaguesList;
        this.state.dataProvider.currentBranch;
        this.state.dataProvider.getSortedLeaguesByBranch;
        this.state.dataProvider.leaguesList.reduce((a, b) => a += b.eventIds.length, 0);
        Object.keys(this.state.dataProvider.masterEvents).reduce((a, b) => {

            return this.state.dataProvider.masterEvents[b].markets.reduce((c, d) => c += d.selections.length, 0);

        }, 0)

        // /\ DO NOT TOUCH THIS EVER!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        return (
            <ContainerQuery query={config.marketsQuery}>
                {(query) => (
                    this.renderBranch(this.state.dataProvider.currentBranch, query)
                )}
            </ContainerQuery>
        )
    }
}